module.exports = __webpack_public_path__ + "static/media/icl_logo.7d467d85.png";